import { createApp, defineAsyncComponent } from 'vue';
import { createPinia } from 'pinia'

import SiteHeader from './components/SiteHeader.vue';
import SearchModalButton from './components/SearchModalButton.vue';

const app = createApp({});
const pinia = createPinia();

app.use(pinia);

app.config.compilerOptions.nativeTemplate = false;
app.config.compilerOptions.whitespace = 'preserve';

// Define asynchronous components
const asyncComponents = {
    // BlogList: defineAsyncComponent(() => import(/* webpackChunkName: 'BlogList' */ './components/BlogList.vue')),
    AccordionItem: defineAsyncComponent(() => import(/* webpackChunkName: 'AccordionItem' */ './components/AccordionItem.vue')),
    // TypeWriter: defineAsyncComponent(() => import(/* webpackChunkName: 'TypeWriter' */ './components/TypeWriter.vue')),
    ProgressBar: defineAsyncComponent(() => import(/* webpackChunkName: 'ProgressBar' */ './components/ProgressBar.vue')),
    DynamicModalButton: defineAsyncComponent(() => import(/* webpackChunkName: 'DynamicModalButton' */ './components/DynamicModalButton.vue')),
    // SearchResults: defineAsyncComponent(() => import(/* webpackChunkName: 'SearchResults' */ './components/SearchResults.vue')),
    TruncatedText: defineAsyncComponent(() => import(/* webpackChunkName: 'TruncatedText' */ './components/TruncatedText.vue')),
    // TruncatedBlock: defineAsyncComponent(() => import(/* webpackChunkName: 'TruncatedBlock' */ './components/TruncatedBlock.vue')),
    // HeroCarousel: defineAsyncComponent(() => import(/* webpackChunkName: 'HeroCarousel' */ './components/HeroCarousel.vue')),
    ModalButton: defineAsyncComponent(() => import(/* webpackChunkName: 'ModalButton' */ './components/ModalButton.vue')),
    TabsWrapper: defineAsyncComponent(() => import(/* webpackChunkName: 'TabsWrapper' */ './components/TabsWrapper.vue')),
    Tab: defineAsyncComponent(() => import(/* webpackChunkName: 'Tab' */ './components/Tab.vue')),
    ImageComparisonSlider: defineAsyncComponent(() => import(/* webpackChunkName: 'ImageComparisonSlider' */ './components/ImageComparisonSlider.vue')),
    NumberCounter: defineAsyncComponent(() => import(/* webpackChunkName: 'NumberCounter' */ './components/NumberCounter.vue')),
    // LottieAnimation: defineAsyncComponent(() => import(/* webpackChunkName: 'LottieAnimation' */ './components/LottieAnimation.vue')),
    ProductGallery: defineAsyncComponent(() => import(/* webpackChunkName: 'ProductGallery' */ './components/ProductGallery.vue')),
    // FadeCarousel: defineAsyncComponent(() => import(/* webpackChunkName: 'FadeCarousel' */ './components/FadeCarousel.vue')),
    ProductCardCarousel: defineAsyncComponent(() => import(/* webpackChunkName: 'ProductCardCarousel' */ './components/ProductCardCarousel.vue')),
    OverviewList: defineAsyncComponent(() => import(/* webpackChunkName: 'OverviewList' */ './components/OverviewList.vue')),
    LogoCarousel: defineAsyncComponent(() => import(/* webpackChunkName: 'LogoCarousel' */ './components/LogoCarousel.vue')),
    ProductConfigurator: defineAsyncComponent(() => import(/* webpackChunkName: 'ProductConfigurator' */ './components/commerce/ProductConfigurator.vue')),
    RemoveFromBasketButton: defineAsyncComponent(() => import(/* webpackChunkName: 'RemoveFromBasketButton' */ './components/commerce/RemoveFromBasketButton.vue')),
    BaseSwiper: defineAsyncComponent(() => import(/* webpackChunkName: 'BaseSwiper' */ './components/BaseSwiper.vue')),
    AccordionListWrapper: defineAsyncComponent(() => import(/* webpackChunkName: 'AccordionListWrapper' */ './components/AccordionListWrapper.vue')),
    ProductSearch: defineAsyncComponent(() => import(/* webpackChunkName: 'ProductSearch' */ './components/ProductSearch.vue')),
};

// Register components asynchronously
for (const [componentName, asyncComponent] of Object.entries(asyncComponents)) {
    app.component(componentName, asyncComponent);
}

app.component('SiteHeader', SiteHeader);
app.component('SearchModalButton', SearchModalButton);

app.mount('#app');